/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Form, Segment, Divider, Modal, Button, Icon, Header, Grid } from "semantic-ui-react";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

class EditTags extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      selectedItemMac: "",
      devices: [],
      dropdownOptions: [],
      openDeleteTagsConfirm: false,
      formInputTag: ""
    };
  }

  retrieveData = async () => {
    let liveList = [];
    let dropdownOptionsList = [];
    let formInputTag = "";

    liveList = await fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(UtilsInstance.checkStatus)
      .then(res => res.json())
      .then(data => data.sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      }))
      .catch((error) => {
        console.log(error);
        return [];
      });

    for (let i = 0; i < liveList.length; i++) {
      if (liveList[i].mac.toString() === this.state.selectedItemMac.toString()) {
        formInputTag = liveList[i].tag;
      }

      dropdownOptionsList.push({
        key: `${liveList[i].mac} - ${liveList[i].name}`,
        value: liveList[i].mac,
        text: <>
          <b>{Strings.IP}:</b> {liveList[i].ip} <b>/</b>
          <b> {Strings.NAME}:</b> {liveList[i].name} <b>/</b>
          <b> {Strings.MAC}:</b> {liveList[i].mac} <b>/</b>
          <b> {Strings.TAG}:</b> {liveList[i].tag}
        </>
      });
    }

    this.setState({
      devices: liveList,
      dropdownOptions: dropdownOptionsList,
      formInputTag: formInputTag
    });
  };

  // When a dropdown option is selected, save the MAC address of the device on the state
  // So we can use it later to send to the server
  handleDropwdownItemClick = (event, info) => {
    if (info.value.toUpperCase() === "") {
      this.setState({
        selectedItemMac: "",
        formInputTag: ""
      });
    }
    else {
      for (let i = 0; i < this.state.devices.length; i++) {
        if (this.state.devices[i].mac.toUpperCase() === info.value.toUpperCase()) {
          let deviceTag = "";

          if (this.state.devices[i].tag !== null) {
            deviceTag = this.state.devices[i].tag;
          }

          this.setState({
            selectedItemMac: this.state.devices[i].mac,
            formInputTag: deviceTag
          });

          break;
        }
      }
    }
  };

  handleSubmit = () => {
    if (this.state.selectedItemMac.toUpperCase() === "") {
      alert(Strings.PLEASE_SELECT_DEVICE);
    }
    else {
      console.log(
        JSON.stringify({
          mac: this.state.selectedItemMac,
          tag: this.state.formInputTag
        })
      );
      fetch(Constants.REQUEST_IP_ADDRESS + "editTag_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({
          mac: this.state.selectedItemMac,
          tag: this.state.formInputTag
        }),
        mode: "cors"
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.CHANGE_TAG_SUCCESS);
          // After changing the tag, get the new data
          this.retrieveData();
        })
        .catch((error) => {
          alert(Strings.CHANGE_TAG_FAILURE + Strings.N_REASON_DP + error);
        });
    }
  };

  handleDeleteTags = () => {
    let deleteTag = {
      delete: true
    };

    let data = JSON.stringify(deleteTag);

    fetch(Constants.REQUEST_IP_ADDRESS + "resetTag_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        this.setState({
          devices: [],
          dropdownOptions: [],
          selectedItemMac: "",
          formInputTag: ""
        }, () => {
          alert(Strings.REMOVE_TAG_SUCCESS);
          this.retrieveData();
        });
      })
      .catch((error) => {
        alert(Strings.REMOVE_TAG_FAILURE + Strings.N_REASON_DP + error);
      })
      .finally(this.closeDeleteTagsConfirm);
  };

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  };

  openDeleteTagsConfirm = () => this.setState({ openDeleteTagsConfirm: true });

  closeDeleteTagsConfirm = () => this.setState({ openDeleteTagsConfirm: false });

  onChangeTagInput = (e, data) => {
    if (data.value.length <= 20) {
      this.setState({
        formInputTag: data.value
      });
    }
  };

  exportTags = () => {
    fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => {
        let tagsInfo = { "Tags": [] };

        for (let i = 0; i < data.length; i++) {
          tagsInfo.Tags.push({
            "mac": data[i].mac,
            "tag": (data[i].tag == null) ? "" : data[i].tag
          });
        }

        let tagsJSONInfo = JSON.stringify(tagsInfo);

        let dataStr = "data:application/json;charset=utf-8," + encodeURIComponent(tagsJSONInfo);
        let downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", "Tags.json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      });
  };

  importTags = () => {
    let fileInput = document.getElementById("import-tags-input-file");

    if (fileInput.files[0] !== undefined && fileInput.files[0] !== null) {
      let file = fileInput.files[0];
      let fileReader = new FileReader();

      // Import the tags information when the file is ready to be read
      fileReader.onload = (event) => {
        try {
          let tagsJSONObject = JSON.parse(event.target.result);
          let areTagsOk = tagsJSONObject.Tags !== undefined && tagsJSONObject.Tags !== null;

          if (areTagsOk) {
            // And save them
            let networkData = JSON.stringify({ Tags: tagsJSONObject.Tags });

            // Try to save the nodes of the network
            fetch(Constants.REQUEST_IP_ADDRESS + "importTags_POST", {
              method: "POST",
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              },
              body: networkData
            })
              .then(UtilsInstance.checkStatus)
              .then(() => {
                alert(Strings.IMPORT_TAGS_SUCCESS);
                // If everything was ok, retrieve data to refresh the page
                this.retrieveData();
              })
              .catch((error) => {
                alert(Strings.IMPORT_TAGS_FAILURE + error);
              });
          }
          else {
            alert(Strings.IMPORT_TAGS_FAILURE + Strings.INVALID_OR_CORRUPT_FILE);
          }
        }
        catch (error) {
          alert(Strings.IMPORT_TAGS_FAILURE + Strings.INVALID_OR_CORRUPT_FILE);
        }
      };

      fileReader.readAsText(file);
    }
    else {
      alert(Strings.PLEASE_SELECT_TAG_FILE);
    }
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    return (
      <Grid className="ts-config-subpage ts-config-tags-page" style={divStyle} columns={2} doubling verticalAlign="middle">

        <Grid.Column>
          <Segment>
            <Divider horizontal>{Strings.ADD_ALTER_TAGS}</Divider>
            <Form onSubmit={this.handleSubmit}>
              <Form.Dropdown
                placeholder={Strings.CHOOSE_DEVICE}
                fluid
                lazyLoad
                //search
                clearable
                selection
                scrolling
                options={this.state.dropdownOptions}
                onChange={this.handleDropwdownItemClick}
              />
              <Form.Input
                value={this.state.formInputTag}
                placeholder={Strings.NEW_TAG}
                onChange={this.onChangeTagInput} />

              <Form.Button color="teal">{Strings.SAVE}</Form.Button>
            </Form>
          </Segment>

          <Segment>
            <Divider horizontal>{Strings.REMOVE_ALL_TAGS}</Divider>
            <Form onSubmit={this.openDeleteTagsConfirm}>
              <Form.Button color="teal">{Strings.REMOVE}</Form.Button>
            </Form>
          </Segment>
        </Grid.Column>

        <Grid.Column>

          <Segment>
            <Divider horizontal>{Strings.IMPORT_TAGS}</Divider>
            <Form onSubmit={() => { this.importTags(); }}>
              <Form.Input id="import-tags-input-file" type="file" accept=".json" />
              <Button color="teal" type="submit" content={Strings.IMPORT} />
            </Form>
          </Segment>

          <Segment>
            <Divider horizontal>{Strings.EXPORT_TAGS}</Divider>
            <Button
              color="teal"
              onClick={() => { this.exportTags(); }}>
              {Strings.EXPORT}
            </Button>
          </Segment>

        </Grid.Column>

        <Modal basic size='small' open={this.state.openDeleteTagsConfirm} >
          <Header icon='trash' content={Strings.REMOVE_ALL_TAGS} />
          <Modal.Content content={Strings.CONFIRM_REMOVE_ALL_TAGS} />
          <Modal.Actions>
            <Button color='red' onClick={this.closeDeleteTagsConfirm}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button color='green' onClick={this.handleDeleteTags}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

      </Grid>
    );
  }
}

const divStyle = {
  margin: "0 auto",
  textAlign: "center"
};

export default EditTags;